import React, { useEffect, useState, useCallback } from "react";
import { Container, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import AllOrdersSocios from "./AllOrdersSocios";
import { toast } from "react-toastify";
import { APIClient } from "../../../helpers/api_helper";

const apiClient = new APIClient();

const TabelaSocios = () => {
  const [loading, setLoading] = useState(false);
  const [orderList, setOrderList] = useState([]);
  const [shouldFetch, setShouldFetch] = useState(true); 

  const fecthSocios = useCallback(
    async () => {
      setLoading(true);
      const user = JSON.parse(localStorage.getItem("authUser"));
      
      const response = await apiClient.get(`/lojista/socios/${user.data._id}`);
      
      if (response.sucesso) {
        return response.data;
      } else {
        toast.error(response.mensagem);
        console.log(response);
        return [];
      }
    },
    [] 
  );

  useEffect(() => {
    if (shouldFetch) {
      const fetchData = async () => {
        const retorno = await fecthSocios();
        setOrderList(retorno);
        setShouldFetch(false);
      };

      fetchData();
    }
  }, [shouldFetch, fecthSocios]);

  document.title = "Sócios | Painel Fort Exchange";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Sócios"
            pageTitle={"Lojista"}
          />
          <Row>
            <AllOrdersSocios
              orderList={orderList}
              loading={loading}
              setShouldFetch={setShouldFetch}
            />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TabelaSocios;
